interface AnySkillLogoProps {
  className?: string;
  size?: number;
}

const AnySkillLogo = ({ className = "", size = 24 }: AnySkillLogoProps) => {
  return (
    <img 
      src="/favicon.svg?v=2" 
      alt="AnySkill Logo"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default AnySkillLogo;
